import script from "./set3id.vue?vue&type=script&lang=ts&setup=true"
export * from "./set3id.vue?vue&type=script&lang=ts&setup=true"

import "./set3id.vue?vue&type=style&index=0&id=4fc3bb11&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc3bb11"]])

export default __exports__